"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));

var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));

var _LocalShipping = _interopRequireDefault(require("@material-ui/icons/LocalShipping"));

var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Item = _interopRequireDefault(require("../components/Item"));

var _Header = _interopRequireDefault(require("../components/Header"));

var _ModalLayout = _interopRequireDefault(require("../components/ModalLayout"));

var View = function View(_ref) {
  var title = _ref.title,
      provider = _ref.provider,
      shipDate = _ref.shipDate,
      trackingNumber = _ref.trackingNumber,
      items = _ref.items,
      onClick = _ref.onClick,
      aside = _ref.aside;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_ModalLayout["default"], {
    aside: aside
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-h-full pb-5 flex flex-col justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow"
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, title), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 600
    }
  }, provider && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_LocalShipping["default"], null)
  }, provider), shipDate && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], null)
  }, shipDate), trackingNumber && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], null)
  }, trackingNumber), items.length > 0 && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_ShoppingCart["default"], null),
    valign: "top"
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: index,
      className: "pb-2 truncate"
    }, item.name);
  })))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-48",
    onClick: onClick
  }, t('sifts.button.trackPackage'))));
};

View.displayName = 'Shipment';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=Shipment.js.map